import { useSelector } from 'react-redux';

/**
 * Custom hook to provide text-related utility functions
 * that automatically pull 'texts' from the Redux store.
 */
export const useTextService = () => {
    // 1. Fetch 'texts' directly from the Redux store
    const { texts } = useSelector((state) => state.texts);

    // 2. Refactor your service functions to use the fetched 'texts'
    //    They no longer need 'texts' as a parameter.

    const getValueByTag = (tag) => {
        const textObject = texts.find((text) => text.tag === tag);
        return textObject && textObject.value ? { __html: textObject.value } : null;
    };

    const getPlainValueByTag = (tag) => {
        const textObject = texts.find((text) => text.tag === tag);
        return textObject ? textObject.value : '';
    };

    // 3. Return the functions for component use
    return {
        getValueByTag,
        getPlainValueByTag,
    };
};